import { getFormKey, getForm } from './utils';

export const NFTPFormLoader = function (element) {
	if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
		return new Promise((resolve, reject) => {
			const formId = element.data('form_id');
			if (!formId) {
				reject(new Error('FormID is not defined'));
				return;
			}
			try {
				const formKey = getFormKey(formId);
				const redirectId = element.data('redirect_id') || 0;

				// Set the form subId to carry form duplications
				if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
					window.flNfFormsLoaded[formKey] = {
						counter: 0,
					};
				} else {
					window.flNfFormsLoaded[formKey].counter += 1;
				}

				getForm(formId, window.flNfFormsLoaded[formKey].counter, { redirect_id: redirectId })
					.then(response => resolve({
						element,
						response,
					}));
			} catch (error) {
				reject(error);
			}
		});
	}
	// Remove after AB#245834 in prod
	return new Promise((resolve, reject) => {
		const formId = element.data('form_id');
		if (!formId) {
			reject(new Error('FormID is not defined'));
		}
		const formKey = getFormKey(formId);
		const redirectId = element.data('redirect_id') || 0;

		// Set the form subId to carry form duplications
		if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
			window.flNfFormsLoaded[formKey] = {
				counter: 0,
			};
		} else {
			window.flNfFormsLoaded[formKey].counter += 1;
		}

		getForm(formId, window.flNfFormsLoaded[formKey].counter, { redirect_id: redirectId })
			.then(response => resolve({
				element,
				response,
			}));
	});
};

export const NFTPFormProcessor = function (formData) {
	const container = $('body');
	formData.element.html(formData.response.form);
	const span = $('<span id="nf_tp_templates_container" />').css('visibility', 'hidden');
	span.html(formData.response.templates);
	container.append(span);
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/contact-forms-lazy-load/nf-tp.js